const url = 'situacoes-indicadores';
class SituacaoIndicadorService {
    async list(params) {
        const res = await window.$http.get(url, params);
        return res?.data ?? [];
    }
}

export default new SituacaoIndicadorService();
